/** @format */

import CKEditorPreview from "./ckeditorPreview";
import Dev from "./Dev";
import AuthFlag from "../../auth/AuthFlag";
import { Trans } from "react-i18next";

const devRoutes = [
  {
    path: ":cardType",
    element: (
      <AuthFlag
        authGroup={["wjec", "admin"]}
        fallback={
          <Trans>
            <h1>Unauthorised</h1>
          </Trans>
        }
      >
        <Dev />
      </AuthFlag>
    ),
  },
  {
    path: "ckeditor",
    element: (
      <AuthFlag
        authGroup={["wjec", "admin"]}
        fallback={
          <Trans>
            <h1>Unauthorised</h1>
          </Trans>
        }
      >
        <CKEditorPreview />
      </AuthFlag>
    ),
  },
];

// TODO: Only translates unauthorised on page reload
// TODO: change authGroup from staff when more roles are added

export default devRoutes;
